export default function videos() {
  const playButtons = [...document.querySelectorAll('.media_vid-container')];

  if (playButtons.length) {
    playButtons.forEach(btn => {
      const videoElement = btn.previousSibling;

      btn.addEventListener('click', function (e) {
        if (videoElement.paused) {
          videoElement.play();
          btn.classList.add('is-hidden');
        } else {
          videoElement.pause();
          btn.classList.remove('is-hidden');
        }
      });
    });
  }
}



// WEBPACK FOOTER //
// ./source/scripts/enhancements/videos.js